module.exports = __webpack_public_path__ + "img/icon-vimeo.svg";